import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db6e5386"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "菜单树", -1))
const _hoisted_3 = { style: {"text-align":"right"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"padding":"0px 20px"} }
const _hoisted_6 = { style: {"overflow-wrap":"break-word"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_radio_search = _resolveComponent("miezz-radio-search")!
  const _component_miezz_button = _resolveComponent("miezz-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_menu_detail = _resolveComponent("menu-detail")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_menu_form = _resolveComponent("menu-form")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_select = _resolveComponent("miezz-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { shadow: "always" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_miezz_radio_search, {
            radioSearch: _ctx.dto.Scene,
            "onUpdate:radioSearch": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dto.Scene) = $event)),
            radioOptions: _ctx.EnumMenuSceneOption,
            all: false,
            disabledSearch: true,
            prop: "Scene",
            int: true,
            onHandleSearch: _ctx.handleRadioSearch
          }, null, 8, ["radioSearch", "radioOptions", "onHandleSearch"]),
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topButtons, (item, i) => {
              return (_openBlock(), _createBlock(_component_miezz_button, {
                key: i,
                model: item,
                onHandleClick: _ctx.handleTopButtonClick
              }, null, 8, ["model", "onHandleClick"]))
            }), 128))
          ])
        ])
      ]),
      default: _withCtx(() => [
        (
        _ctx.listInvalidWebApi.Data?.Items && _ctx.listInvalidWebApi.Data.Items.length > 0
      )
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: `检测到已失效的接口共 ${_ctx.listInvalidWebApi.Data.Items.length} 个`,
              type: "error",
              effect: "light",
              "show-icon": "",
              closable: "",
              style: {"margin-bottom":"15px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalInvalidWebApi.Show = true))
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tree, {
          ref: "treeRef",
          "node-key": "Id",
          data: _ctx.models,
          props: _ctx.props,
          "expand-on-click-node": false,
          "default-expand-all": "",
          draggable: "",
          onNodeDrop: _ctx.handleDrop
        }, {
          default: _withCtx(({ data }) => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_tag, {
                class: "node-tag",
                style: _normalizeStyle(data.MarkerColor ? `color: ${data.MarkerColor}` : ''),
                type: "info",
                onClick: ($event: any) => (_ctx.handleNodeClick(data))
              }, {
                default: _withCtx(() => [
                  (data.Remark)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        content: data.Remark,
                        placement: "bottom",
                        effect: "light"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(data.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["content"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(data.Name), 1))
                ]),
                _: 2
              }, 1032, ["style", "onClick"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.RightItems, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: i,
                  class: "node-tag",
                  style: _normalizeStyle(item.MarkerColor ? `color: ${item.MarkerColor}` : ''),
                  type: "info",
                  onClick: ($event: any) => (_ctx.handleNodeClick(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.Name), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "onClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["data", "props", "onNodeDrop"])
      ]),
      _: 1
    }),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalDetail,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalDetail) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_menu_detail, {
          modelValue: _ctx.modalDetail,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalDetail) = $event)),
          id: _ctx.id,
          onHandleSubmit: _ctx.handleSubmit,
          onHandleDelete: _ctx.handleDelete
        }, null, 8, ["modelValue", "id", "onHandleSubmit", "onHandleDelete"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalForm,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalForm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_menu_form, {
          modelValue: _ctx.modalForm,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalForm) = $event)),
          ref: "menu-form",
          id: _ctx.id,
          path: _ctx.path,
          scene: _ctx.dto.Scene,
          onHandleSubmit: _ctx.handleSubmit
        }, null, 8, ["modelValue", "id", "path", "scene", "onHandleSubmit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalInvalidWebApi,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalInvalidWebApi) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_page_list, {
          modelValue: _ctx.listInvalidWebApi,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listInvalidWebApi) = $event)),
          onHandleRowButtonClick: _ctx.handleRowButtonClick
        }, null, 8, ["modelValue", "onHandleRowButtonClick"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalRepairInvalidWebApi,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalRepairInvalidWebApi) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, " 接口：" + _toDisplayString(_ctx.invalidWebApi?.ControllerSummary) + " / " + _toDisplayString(_ctx.invalidWebApi?.Summary), 1),
          _createElementVNode("p", _hoisted_6, "位置：" + _toDisplayString(_ctx.invalidWebApi?.Name), 1),
          _createElementVNode("div", null, [
            _createTextVNode(" 菜单： "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invalidWebApi?.JoinMenuWebApis, (item, i) => {
              return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(item.MenuPath) + _toDisplayString(item.MenuName), 1))
            }), 128))
          ]),
          _createElementVNode("div", null, [
            _createTextVNode(" 更新为： "),
            _createVNode(_component_miezz_select, {
              id: "webApiId",
              modelValue: _ctx.webApiId,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.webApiId) = $event)),
              options: _ctx.webApiFilterSelectOptions,
              "filter-Method": _ctx.webApiFilter
            }, {
              default: _withCtx(({ model }) => [
                _createElementVNode("div", {
                  class: _normalizeClass('api_color_' + model.data.Data.Method)
                }, _toDisplayString(model.data.Label), 3)
              ]),
              _: 1
            }, 8, ["modelValue", "options", "filter-Method"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}